import React from 'react';
import { motion } from 'framer-motion';
export function FloatingParticles() {
  const particles = Array.from({
    length: 20
  }, (_, i) => ({
    id: i,
    size: Math.random() * 4 + 2,
    x: Math.random() * 100,
    y: Math.random() * 100,
    duration: Math.random() * 10 + 10,
    delay: Math.random() * 5
  }));
  return <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-37">
      {particles.map(particle => <motion.div key={particle.id} className="absolute rounded-full bg-matrix-accent/20" style={{
      width: particle.size,
      height: particle.size,
      left: `${particle.x}%`,
      top: `${particle.y}%`
    }} animate={{
      y: [0, -30, 0],
      x: [0, 15, -15, 0],
      opacity: [0.2, 0.5, 0.2]
    }} transition={{
      duration: particle.duration,
      repeat: Infinity,
      delay: particle.delay,
      ease: 'easeInOut'
    }} data-id="element-38" />)}
    </div>;
}